import React, { memo } from 'react';
import PropTypes from 'prop-types';

import PinLocationIcon from 'assets/v2/PinLocationIcon';
import PinLocationOutlineIcon from 'assets/v2/PinLocationOutlineIcon';
import { COLORS } from 'theme';
import {
  CardDataIconValueContainer,
  CardDataLocationContainer,
  CardDataLocationAddressText,
  CardDataLabel,
} from './styles';

const CardDataLocation = ({ addressText, label, isDestination }) => (
  <CardDataLocationContainer>
    <CardDataIconValueContainer>
      {isDestination ? (
        <PinLocationIcon fontSize="small" sx={{ color: COLORS.kinetikBlue }} />
      ) : (
        <PinLocationOutlineIcon
          fontSize="small"
          sx={{ color: COLORS.kinetikBlue }}
        />
      )}
      <CardDataLocationAddressText>{addressText}</CardDataLocationAddressText>
    </CardDataIconValueContainer>
    <CardDataLabel>{label}</CardDataLabel>
  </CardDataLocationContainer>
);

CardDataLocation.propTypes = {
  addressText: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  isDestination: PropTypes.bool,
};

export default memo(CardDataLocation);
